import React from 'react';
import { CareerSearchBar } from '../CareerSearchBar';
import PulseCard from '../PulseCard';
import { MessageDescriptor } from 'react-intl';
import { useLayoutSize, WrappedMessage } from 'utils';
import { Icon } from 'elements';

interface FilterHeaderProps {
  filterLabel: MessageDescriptor;
  onSubmit: (query: string) => void;
  onReset: () => void;
  onClose: () => void;
  disableSearch?: boolean;
}

const FilterHeader: React.FC<FilterHeaderProps> = ({
  filterLabel,
  onSubmit,
  onReset,
  onClose,
  disableSearch,
}) => {
  const isMobile = ['small', 'mobile'].includes(useLayoutSize());

  const getCloseButton = () => (
    <button className='close-button' onClick={onClose}>
      <Icon name='career-close' fill={'#497595'} />
    </button>
  );

  return (
    <div className='header-container'>
      <div className='header'>
        {isMobile && getCloseButton()}
        <strong className='title'>
          <WrappedMessage message={filterLabel} />
        </strong>
        <button className='reset-button' onClick={onReset}>
          <PulseCard>
            <span className='button-label'>Reset</span>
          </PulseCard>
        </button>
      </div>
      {!disableSearch && (
        <CareerSearchBar
          onSubmit={onSubmit}
          viewType='other'
          enableAutoSearch
        />
      )}
    </div>
  );
};

export default FilterHeader;
